// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2GGVT","signatureBlock":"Footer_signatureBlock__1-qLc","signature":"Footer_signature__6wUtx"};